import { client } from "../../../Infrastructure/agent";

export const naocDailyProductionService = {
  downloadTemplate: () =>
    client.getFile("/NaocDailyProduction/DownloadNaocDailyProductionTemplate"),
  saveDailyProduction: (data, uploadedBy) =>
    client.post("/NaocDailyProduction/SaveDailyProduction", {
      data,
      uploadedBy,
    }),

  loadProductionHistory: (query, view) =>
    client.post("/NaocDailyProduction/LoadProductionHistory", {
      query,
      view,
    }),
  deleteProduction: (id) =>
    client.post("/NaocDailyProduction/DeleteProduction", {
      id,
    }),

  exportPodSummary: (startDate, endDate) =>
    client.getFile(
      `/NaocDailyProduction/ExportPODSummaryToExcel?startdate=${startDate}&enddate=${endDate}`
    ),
  getNaocDailProductionById: (productionId, view) =>
    client.post("/NaocDailyProduction/GetDailyProduction", {
      productionId,
      view,
    }),
  
};

